import moment from 'moment';

export default {
    methods: {
        /**
         * format 365-day historical data into 18 months of daily data
         * @param  {Array} data365days 365-day data
         * @param  {Function} formatter   formatter callback
         * @return {Array}             formatted 18-month data
         */
        formatHistoricalData(data365days, formatter) {
            // build 18 months of historical values from 12 months of data
            // use the last 13 months, plus the next 5 months

            // clone the year of data to form last year, this year, next year
            const today = moment();
            const yearStart = moment().subtract(1, 'years').startOf('year');
            let data3Years = data365days.concat(data365days, data365days);
            data3Years = data3Years.map((e, i) => {
                const date = yearStart.clone().add(i, 'days');

                return formatter(date, e);
            });

            // the first of this month, last year
            const currentMonth = today.format('MM');
            let periodStart = moment(`${yearStart.format('Y')}-${currentMonth}-01`);
            // period start + 19 months, - 1 day (end of 18 months later)
            let periodEnd = periodStart.clone()
                .add(19, 'months')
                .subtract(1, 'days');

            // trim the array to just this 18-month period
            periodStart = data3Years.findIndex(e => e.d.isSame(periodStart));
            periodEnd = data3Years.findIndex(e => e.d.isSame(periodEnd));
            const data18Months = data3Years.slice(periodStart, periodEnd);
            return data18Months;
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/formatHistoricalDailyData.js